import React, { useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Title } from 'app/src/styles';
import { useNavigate } from 'app/src/utils/routing';

import { CREATE_LIBRARY } from './queries';

export const FIELDS = {
  name: {
    label: 'Name',
    rules: { required: true },
  },
  access: {
    label: 'Access Level',
    rules: { required: true },
    select: [
      { value: '', label: 'Select' },
      { value: 'private', label: 'Private' },
      { value: 'shareable', label: 'Shareable' },
      { value: 'public', label: 'Public' },
    ],
  },
  description: {
    label: 'Description',
  },
};

const NewLibrary = () => {
  const [formStatus, setFormStatus] = useState();
  const navigate = useNavigate();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [createLibrary] = useMutation(CREATE_LIBRARY, {
    onCompleted: data => {
      navigate(`/libraries/${data.createLibrary.library.id}`)
    }
  });

  const onSubmit = input => {
    setFormStatus('submitting');
    createLibrary({ variables: { input: prepareInput(input, FIELDS) } });
  };

  const fields = { ...FIELDS };

  return (
    <View>
      <Title>Add Library</Title>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button
          label="Save to add things and event types"
          onPress={handleSubmit(onSubmit)}
          wide
        />
      )}
    </View>
  );
};

export default NewLibrary;
